<template>
  <div style="word-break: normal" class="agreement py-6 px-10 text-black">
    <div class="flex justify-end">
      <app-logo />
    </div>
    <div class="mt-4">
      <p class="text-center font-bold text-xl mb-4">
        Self-Directed Custodial Account and Deposit Agreement
      </p>
      <p>
        This Self-Directed Custodial Account and Deposit Agreement ("Agreement")
        is made and entered into as of [Date] ("Effective Date") by and between
        <span class="font-bold">Oval Finance</span> , a custodian company
        located at [Walkers Corporate (Bermuda) Limited Park Place, 55 Par La
        Ville Road, Third Floor, Hamilton Bermuda] ("Custodian"), and
        <span class="font-bold">[Account Holder's Name]</span>, an individual
        located at <span class="font-bold">[Address]</span> ("Account Holder" or
        "Customer").
      </p>
      <div v-for="(section, key) in depositAgreement" :key="key">
        <span v-if="key === 4" class="page-break"></span>
        <p class="mt-6 font-bold">{{ section.title }}</p>
        <ol v-if="section.content.length !== 1" class="pl-4">
          <li v-for="(item, index) in section.content" :key="index">
            {{ item.list }}
          </li>
        </ol>
        <p v-else>
          {{ section.content[0].list }}
        </p>
      </div>
      <div>
        <p class="mt-6 font-bold">Account Holder:</p>
        <p class="flex gap-x-6 mt-4">
          Signature:
          <span class="sign flex-1">{{
            user.lastName + ' ' + user.firstName
          }}</span>
        </p>
        <p class="flex gap-x-10 mt-4">
          Name:
          <span class="flex-1">{{ user.lastName + ' ' + user.firstName }}</span>
        </p>
        <p class="flex gap-x-10 mt-4">
          Email: <span class="flex-1">{{ user.email }}</span>
        </p>
        <p class="flex gap-x-12 mt-4">
          Date: <span class="flex-1">{{ dayCreated }}</span>
        </p>
        <span class="page-break"></span>
        <p class="mt-6 font-bold">Oval Finance:</p>
        <p class="flex gap-x-6 mt-4">
          Signature: <span class="sign flex-1">{{ treasuryData[0].name }}</span>
        </p>
        <p class="flex gap-x-10 mt-4">
          Name: <span class="flex-1"> {{ treasuryData[0].name }}</span>
        </p>
        <p class="flex gap-x-6 mt-4">
          Position: <span class="flex-1">{{ treasuryData[0].position }}</span>
        </p>
        <p class="flex gap-x-10 mt-4">
          Email: <span class="flex-1">{{ treasuryData[0].email }}</span>
        </p>
        <p class="flex gap-x-12 mt-4">
          Date: <span class="flex-1">{{ dayCreated }}</span>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { FormatDate } from '@/utils/helpers.js'
import { OVAL_DEPOSIT_AGREEMENT, TREASURY_INFO } from '@/utils/constants.js'
export default {
  components: {
    AppLogo: () => import('@/assets/images/AppLogo.vue')
  },
  data () {
    return {
      depositAgreement: OVAL_DEPOSIT_AGREEMENT,
      treasuryData: TREASURY_INFO
    }
  },
  computed: {
    business () {
      return this.$store.state.auth.business
    },
    user () {
      return this.$store.state.auth.user
    },
    dayCreated () {
      return this.$dayjs(this.user.createdAt).add(1, 'day').format('YYYY-MM-DD')
    }
  },
  methods: {
    formatDate (val) {
      return FormatDate(val)
    }
  }
}
</script>

<style scoped>
.agreement {
  font-family: 'Times New Roman';
  font-size: medium;
}
.page-break {
  page-break-after: always;
}
.sign {
  font-family: 'Sacramento';
  font-weight: bolder;
  font-size: 22px;
  font-style: italic;
  text-decoration: underline;
}
</style>
